module.exports = __webpack_public_path__ + "3723df84450d1b30e99aa2d4d7a41edb.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1086
// module chunks = 0